import React, { useEffect, useState } from "react";
import RidersMap from "./RidersMap";
import { fireApp } from "../../firebase/firebaseInit";
import { getDatabase, ref, onValue } from "firebase/database";

export default function ({ rider, rider_company_id = "" }) {
  const rider_id = rider?.id;
  const company_id = rider_company_id;
  const database = getDatabase(fireApp);

  const [locationList, setLocationList] = useState({});

  useEffect(() => {

    if (!company_id || !rider_id) {
      console.error("Missing company_id or rider_id");
      return;
    }

    const dbPath = company_id + "/" + rider_id;
    const locationRef = ref(database, dbPath);

    const unsubscribe = onValue(locationRef,
      (snapshot) => {
        const location = snapshot.val();
        setLocationList({ location });
      },
      (error) => {
        console.error('CourierMapWrapper - Firebase error:', error);
      }
    );

    return () => {
      console.log('CourierMapWrapper - cleaning up listener');
      unsubscribe();
    };
  }, [database, company_id, rider_id]);

  return (
    <div>
      <RidersMap locationList={locationList} />
    </div>
  );
}
